export interface ILoginWithGoogleRequest {
    GoogleCode: string;
    Checksum: string;
    DeviceID: string;
    CheckEmpty(): boolean;
}

export class LoginWithGoogleRequest implements ILoginWithGoogleRequest {

    public GoogleCode: string;
    public Checksum: string;
    public DeviceID: string;

    public CheckEmpty(): boolean {

        if (this.GoogleCode === '')
            return false;
        else
            return true;

    }

}
